import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="evenodd" transform="translate(0 2)">
      <path fillRule="nonzero"
            d="M2,6 C1.448,6 1,5.552 1,5 L1,2 C1,1.448 1.448,1 2,1 L14,1 C14.553,1 15,1.448 15,2 L15,5 C15,5.552 14.553,6 14,6 L2,6 Z M15,8 L15,11 C15,11.553 14.553,12 14,12 L2,12 C1.448,12 1,11.553 1,11 L1,8 C1,7.448 1.448,7 2,7 L14,7 C14.553,7 15,7.448 15,8 Z M16,5 L16,2 C16,0.896 15.104,0 14,0 L2,0 C0.896,0 0,0.896 0,2 L0,5 C0,5.601 0.271,6.133 0.69,6.5 C0.271,6.867 0,7.399 0,8 L0,11 C0,12.104 0.896,13 2,13 L14,13 C15.104,13 16,12.104 16,11 L16,8 C16,7.399 15.729,6.867 15.311,6.5 C15.729,6.133 16,5.601 16,5 Z"/>
      <circle cx="4.5" cy="9.5" r="1.5"/>
      <circle cx="4.5" cy="3.5" r="1.5"/>
      <rect width="1" height="3" x="12" y="8"/>
      <rect width="1" height="3" x="10" y="8"/>
      <rect width="1" height="3" x="12" y="2"/>
      <rect width="1" height="3" x="10" y="2"/>
    </g>
  </svg>
);
